import React, { useState } from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

export default class iCmrDtl extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
        this.$cd_stss,
        this.$id_stss
    );

    bf.myCM_clw(3, () => { // 10秒おきに表示を更新
      if ( this.state.sb_etr == true && this.state.sgcd_pageModes[this.state.sgc_pageName] == 'show' ) {
        let _cnd = bf.q('[_KEY]={}'.f(this.state.sgcd_pageCmns?.it10_key));
        ip.$ip_hlr_it10({
          mode: 'get',
          cnd: _cnd,
        })
        .then( _d_is => {
          if ( _d_is.it10cy30 != this.state.s_it10cy30 ) {
            this.load();
          };
        });
      };
    });
  }

  $ip_onEtr = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: true,
    }, () => {
      _o_end1();
    })
  });

  $ip_onExit = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: false,
    }, () => {
      _o_end1();
    })
  });

  //
  $id_stss = {
    //
    sld_cm10ss: [], // スタッフ一覧
    sld_cm50ss: [], // コース一覧
    sld_im10ss: [], // バインダ一覧
    //
    sld_it11ss: [], // 外販担当者
    //
    sld_it31ss: [], // 関与者
    //
    s_it10b21k: '-1', // バインダ席
    s_it10b31k: '', // 日別情報
    s_it10s110: '0', // サービス状況
    s_it10i110: '', // コース
    s_it10i210: '0', // サービス#1
    s_it10i220: '0', // サービス#2
    //
    s_it10i310: '0', // 顧客数（常連）
    s_it10i320: '0', // 顧客数（新規）
    s_it10i330: '0', // 顧客数（合計）
    s_it10i340: '0', // 外販顧客数（合計）
    s_it10i350: '0', // 延長顧客数（合計）
    //
    s_it10i410: 'その他', // 顧客名
    //
    s_it10i510: '0', // コース時間（基本）
    s_it10i520: '0', // コース時間（延長）
    s_it10i530: '0', // コース時間（合計）
    //
    s_it10i610: '0', // コース料金（基本）
    s_it10i620: '0', // コース料金（追加）
    s_it10i640: '0', // コース料金（合計）
    //
    s_it10i710: '0', // 決済方法
    //
    s_cm20ii110: '15', // アラート時間（分）
    s_cm20ii210: '0', // サービス割引額＃１
    s_cm20ii220: '0', // サービス割引額＃２
    //
    sb_ste: false, // 最下行へのスクロール 
  };
  //
  $ilp_bfrLoads = () => [
  ];
  //
  $ilp_loads = () => [

/*
    new Promise( _o_end1 => {
      ip.$ip_load_it10({ // 入店情報
        mode: 'set',
        b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
        it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
        it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
      })
      .then(() => {

        cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
          cm20_key: bf.f(global.c?.state.s_it10b11k) ? global.c?.state.s_it10b11k : global.c?.state.sgcd_pageCmns.cm20_key,
        })
        .then(() => {
          Promise.all([
            ip.$ip_load_it50({ //日別情報 myCB_callQrys において it60_key を取得するために必要
              mode: 'set',
              b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
              cnd: bf.q('[_KEY]={}'.f(global.c?.state.s_it10b31k)),
            }),
            cp.$cp_load_cm50({ // コース情報
              mode: 'items',
              b_wotDlt: true,
              state: 'sld_cm50ss',
              cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                global.c?.state.sgcd_pageCmns?.cm20_key
              )),
            }),
            new Promise( _o_end1 => {
              cp.$cp_load_cm10({ // スタッフ情報
                mode: 'items',
                b_wotDlt: true,
                state: 'sld_cm10ss',
                cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
              })
              .then(() => {
                global.c?.setState({
                  sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                    _next
                    .map( (_d_cm10s, _idx) => {
                      if (
                        bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                        bf.n(_d_cm10s.val.cm10cz10) != 10
                      ) {
                        _d_cm10s.b_hide = true;
                      }
                      else {
                        _d_cm10s.b_hide = false;
                      }
                    })
                  }),
                }, () => {
                  _o_end1();
                });
              })
            }),
            cp.$cp_load_cm50({ // 商品一覧
              mode: 'items',
              b_wotDlt: true,
              state: 'sld_cm50ss2',
              cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] NOT LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                global.c?.state.sgcd_pageCmns?.cm20_key,
              )),
            }),
            ip.$ip_load_im10({ // バインダ情報
              mode: 'items',
              b_wotDlt: true,
              state: 'sld_im10ss',
              cnd: bf.q('[im10b11k]="{}" AND IFNULL([im10cz10],"10")<>"0"'.f(
                global.c?.state.sgcd_pageCmns?.cm20_key
              )),
            }),
            ip.$ip_load_cm2i({ // 利用者グループ属性情報＃i
              mode: 'set',
              cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
            }),
            new Promise( _o_end1 => { // 商品情報
              cf.myCB_call_slc({
                ctr: 'nlm',
                elm: 'cm50',
                n_dms: 3,
                cnd: bf.q('[cm50b11k]="{}"'.f(
                  global.c?.state.sgcd_pageCmns.cm20_key,
                )),
                do_rfrs: {
                  cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
                }
              })
              .then( _ld_cm50ss => {
                let _d = {};
                _ld_cm50ss
                .map( _d_cm50s => {
                  _d[_d_cm50s._KEY] = _d_cm50s;
                });
                global.c?.setState({
                  sdd_cm50ss: _d,
                }, () => {
                  _o_end1();       
                });
              })
            }),
          ])
          .then(() => {
            _o_end1();
          });

        })
      });

    }),
    ip.$ip_load_it11({ // 外販担当者
      mode: 'clds',      
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      state: 'sld_it11ss',
      it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
    }),
    ip.$ip_load_it30({ // 注文情報の反映 // エラーが発生した場合は t_it31 が生成されていることを確認
      mode: 'clds',
      state: 'sld_it30ss',
      it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
    }),
*/
    ip.op_loadAll({
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      cnd: bf.q(`[_KEY]={}`.f(global.c?.state.sgcd_pageCmns?.it10_key)),
    }),
  ];

  $ip_ins = () => new Promise( _o_end1 => {
    //
    // サービス情報を追加
    let _d_vals = {
      it10b11k: global.c?.state.sgcd_pageCmns?.cm20_key, // 店舗情報
      it10b21k: global.c?.state.s_it10b21k, // 座席情報
      it10b31k: global.c?.state.s_it10b31k, // 日別情報
      it10s110: global.c?.state.s_it10s110, // コース状況
      it10d110: global.c?.state.s_it10d110, // コース開始日時
      it10d120: global.c?.state.s_it10d120, // コース終了日時
    };
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'it10', 
      d_vals: _d_vals
    })
    .then( _d_it10s => {
      cf.myRN_setCmns({
        it10_key: _d_it10s._KEY,
      })
      .then(() => {
        _o_end1(_d_it10s);
      });
    });
  });

  $ilp_upds = () => [
/*
    ip.$ip_upd_it10({
      it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
    }), // 顧客情報

    ip.$ip_ups_it30({
      cm10_key: global.c?.state.sgcd_pageCmns?.user_key,
    }), // 注文情報
*/
/*
    new Promise( _o_end1 => {
      ip.$ip_upd_it10({
        it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
      })
      .then(() => {
        cf.myCB_callQrys({
          l_tgts: [
            'it50i220', // カード払額
            'it50i850', // 現在組数
            'it50i870', // 組数合計 
            'it50i920', // 新規客数
            'it10i330', // 客数合計
            'it10ia70', // 支払総額
          ],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.s_it50b21k,
            it50_key: global.c?.state.s_it10b31k,
            it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    }),

    new Promise( _o_end1 => {// 注文情報
      ip.$ip_ups_it30({
        cm10_key: global.c?.state.sgcd_pageCmns?.user_key,
      })
      .then(() => {
        cf.myCB_callQrys({
          l_tgts: [
            'it10i340', // 外販客数
            'it10i520', // コース延長時間
            'it31i130', // 貢献度
            'it10ia70', // 支払総額
          ],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.s_it50b21k,
            it50_key: global.c?.state.s_it10b31k,
            it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    }),

//    ip.$ip_ups_it11(), // 外販担当者
    new Promise( _o_end1 => {// 外販担当者
      ip.$ip_ups_it11()
      .then(() => {
        cf.myCB_callQrys({
          l_tgts: ['it10i340'],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.s_it50b21k,
            it50_key: global.c?.state.s_it10b31k,
            it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    }),

    new Promise( async _o_end1 => { // 入席情報の更新
      if (global.c?.state.s_it10s110 == '20') { // 退店済の場合、全ての入席情報を退席済に変更
        let _qry = bf.q(`
          UPDATE
            [t_it20]
          SET
            [it20s110]="20",
            [it20d120]="{}"
          WHERE
            [it20b11k]="{}" AND [it20s110]<>"20"
        `.f(
          bf.myDT_get_now(),
          global.c?.state.sgcd_pageCmns?.it10_key,
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it20', 
          qry: _qry
        })
        .then(() => {
          _o_end1();
        })
      }
      else {
        _o_end1();
      };
    }),
  ];
*/
    new Promise( _o_end1 => {
      // 入店時刻情報
      ip.$ip_upd_it10({ 
        it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
      })
      .then(() => {　
        // 外販担当者情報
        ip.$ip_ups_it11()
        .then(() => { 
          // 注文情報
          ip.$ip_ups_it30({
//            cm10_key: global.c?.state.sgcd_pageCmns?.user_key,
            cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
          })
          .then(() => {
            cf.myCB_callQrys({
              l_tgts: [
                'it10i730', // カード払額 ※ it30 関係なし
                'it10i330', // 客数（現客数・新規客数・外販客数・延長客数・時間帯別客数・組数・現組数の更新を含む） ※ it30 関係なし
                'it10d120', // 終了時刻 ※ it30 関係あり
                'it10ia70', // 支払総額 ※ it30 関係あり
                'it31i130', // 貢献度 ※ it30 関係あり
              ],
              dd_qryss: ip.dd_qryss,
              d_vals: {
                it60_key: global.c?.state.s_it50b21k,
                it50_key: global.c?.state.s_it10b31k,
                it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
              },
            })
            .then(() => {
              _o_end1();
            });
          });
        });
      });
    }),

    new Promise( async _o_end1 => { // 入席情報の更新
      if (global.c?.state.s_it10s110 == '20') { // 退店済の場合、全ての入席情報を退席済に変更
        let _qry = bf.q(`
          UPDATE
            [t_it20]
          SET
            [it20s110]="20",
            [it20d120]="{}"
          WHERE
            [it20b11k]="{}" AND [it20s110]<>"20"
        `.f(
          bf.myDT_get_now(),
          global.c?.state.sgcd_pageCmns?.it10_key,
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it20', 
          qry: _qry
        })
        .then(() => {
          _o_end1();
        })
      }
      else {
        _o_end1();
      };
    }),

  ];

  _onPrsStt = () => { //　接客開始
    // 現在時刻の格納
    let _now = bf.myDT_get_now();

    // バインダの使用状況を確認
    let _cnd = '';
    if ( global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new' ) {
      _cnd = bf.q('[it10b31k]="{}" AND [it10b21k]="{}" AND [it10s110]="10"'.f(
        global.c?.state.s_it10b31k,
        global.c?.state.s_it10b21k,
      ));
    }
    else {
      _cnd = bf.q('[it10b31k]="{}" AND [it10b21k]="{}" AND [it10s110]="10" AND [_KEY]<>{}'.f( // 再開の場合は自身との重複チェックが必要
        global.c?.state.s_it10b31k,
        global.c?.state.s_it10b21k,
        global.c?.state.sgcd_pageCmns?.it10_key,
      ));
    }

    ip.$ip_load_it10({
      mode: 'get',
      cnd: _cnd,
    })
    .then( _d_it10s => {
      if (!bf.f(_d_it10s)) { // バインダが使用中でない場合
        global.c?.setState({
          s_it10s110: '10', // サービス状況
          s_it10i360: global.c?.state.s_it10i330, // 最終客数
        }, () => {
          ip._updIt10d110()
          .then( ip._updIt10i510 )
          .then( ip._updIt10i530 )
          .then( ip._updIt10d120 )
          .then( () => {
            if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') { // 新規の場合
              global.c?.ins();
            }
            else { // 既存の場合
              global.c?.upd();
            };
          });
        });
      }
      else {
        alert('使用中のため、他のバインダを選択してください')
      }
    })
  };

  _onPrsEnd = () => { // 接客終了・会計確定
    //
    let _d_vals = {
      it20s110: '20',
      it20d120: bf.myDT_get_now(),
    };
    let _cnd = bf.q('[it20b11k]="{}"'.f(
      global.c?.state.sgcd_pageCmns?.it10_key,
    ));
    cf.myCB_call_iud({
      ctr: 'upd',
      elm: 'it20',
      d_vals: _d_vals,
      cnd: _cnd,
    })
    .then(() => {
      global.c?.setState({
        s_it10s110: '20', // 接客状況
      }, () => {
        global.c?.upd();
      });
    });
  };

  _onPrsReStt = () => { // 接客再開
    //
    // バインダの使用状況を確認
    let _cnd = bf.q('[it10b31k]="{}" AND [it10b21k]="{}" AND [it10s110]="10" AND [_KEY]<>{}'.f( // 再開の場合は自身との重複チェックが必要
      global.c?.state.s_it10b31k,
      global.c?.state.s_it10b21k,
      global.c?.state.sgcd_pageCmns?.it10_key,
    ));
    ip.$ip_load_it10({
      mode: 'get',
      cnd: _cnd,
    })
    .then( _d_it10s => {
      if (!bf.f(_d_it10s)) { // バインダが使用中でない場合
        // レジ開設中でない場合は接客再開不可
        let _cnd = bf.q(`
          [_KEY]={} AND 
          [it50s110]="10"
        `.f(
          global.c?.state.s_it10b31k,
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'it50', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_it50s => {
          if (bf.f(_d_it50s)) {
            global.c?.setState({
              s_it10s110: '10', // サービス状況
            }, () => {
              global.c?.upd();
            });
          }
          else {
            alert('レジが開設中でないため、接客を再開できません。');
          }
        });
      }
      else {
        alert('バインダが使用中のため、接客を再開できません')
      }
    });
  };

  $ild_onChgss = ip.ild_onChgss; // individual app change

  $pdo_onChgs = () => ({ // iSrvDtl と同一
/*
    s_it10i110: () => {
      ip._updCm50();
      ip._updCm5i();
    },
*/
    s_it10i110: () => {
      ip._updCm50();
      ip._updCm5i()
      .then( ip._updIt30i210 )
      .then( ip._updIt30i230 );
    },
    s_cm50i110: () => ip._updIt10i610,
    s_cm5ii110: () => ip._updIt10i510,
    s_cm5ii210: () => ip._updIt10ia80,
    s_cm5ii220: () => ip._updIt10ia90,
    s_cm2ii310: () => ip._updIt10ia40,
    s_cm2ii320: () => ip._updIt10ia40,
    s_it10d110: () => ip._updIt10i510,
//    s_it10d120: () => ip._updDsp00,
    s_it10d120: () => {
      ip._updDsp00();
      ip._updIt10d130();
      ip._updIt10d140();
    },
    s_it10d130: () => ip._updDsp30,
    s_it10d140: () => ip._updDsp60,
    s_it10i220: () => ip._updIt10ia40,
    s_it10i2a0: () => ip._updIt10ia40,
    s_it10i2b0: () => ip._updIt10ia40,
    s_it10i310: () => ip._updIt10i330,
    s_it10i320: () => ip._updIt10i330,
    s_it10i330: () => ip._updIt10i610,
    s_it10i510: () => ip._updIt10i530,
    s_it10i520: () => ip._updIt10i530,
    s_it10i530: () => ip._updIt10d120,
    s_it10i730: () => ip._updIt10i720,
    s_it10ia70: () => {
      ip._updIt10i720();
      ip._updIt10ia80();
      ip._updIt10ia90();
      ip._updDsp00();
    },
    s_it10ia80: () => ip._updDsp30,
    s_it10ia90: () => ip._updDsp60,

    s_it10ia40: () => ip._updIt10ia70, // 割引総額 -> 支払総額
    s_it10ia50: () => ip._updIt10ia40, // 会計調整額 -> 割引総額
  }); // app module change

  render() {

    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          b_logo={false}
          b_ste={ global.c?.state.sb_ste }
          b_rhtVsb={(bf.i(global.c?.state.s_it10s110, ['0', '10'])) ? true : false}
          rhtPfx={null}
          rhtIconName={null} 
          onRhtPrs={null}
          d_hdrs={{
            pfx:  iv._get_hdrPfx('入店時刻情報'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
            d_subMenus: {
              b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
              ld_iss: [
                {
                  pfx: '登録日時で並び替え',
                  onPrs: () => {
                    global.c?.setState({
                      sld_it30Sortss: [
                        { fld: 'it30cy10', dtn: 'desc', mode: 'str'}
                      ],
                    });
                  },
                },
                {
                  pfx: '商品で並び替え',
                  onPrs: () => {
                    global.c?.setState({
                      sld_it30Sortss: [
                        { fld: 'cm50cx10', dtn: 'asc', mode: 'nmb'},
                        { fld: 'cm50_key', dtn: 'asc', mode: 'nmb'}
                      ],
                    });
                  },
                },
                {
                  pfx: '登録者で並び替え', // 登録者？
                  onPrs: () => {
//bf.l('486: {}'.f(global.c?.state.sld_it30ss))
                    global.c?.setState({
                      sld_it30Sortss: [
                        { fld: 'cm1ii110', dtn: 'asc', mode: 'nmb'},
                        { fld: 'cm1ib11k', dtn: 'asc', mode: 'nmb'},
//                        { fld: 'it30cy20', dtn: 'asc', mode: 'nmb'}
//                        { fld: 'it30b21k', dtn: 'asc', mode: 'nmb'}
                      ],
                    });
                  },
                },
              ],
            }
          }}
          d_bdys={{
            ld_defss: [
              {
                type: 'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10t110',
                pfx: '入店区分（接客開始前に選択要）',
                ld_itemss: [
                    {key:'10', pfx: '新規入店'},
                    {key:'20', pfx: '出戻り'},
                ],
                onCls:null,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10i410',
                pfx:'顧客名',
                b_mln:false,
                onChg: null,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10i310',
                pfx:'客数（常連）',
                b_mln:false,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10i320',
                pfx:'客数（新規）',
                b_mln:false,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: false,
                state:'s_it10i330',
                pfx:'総客数', // 自動計算
                b_mln:false,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['edit'])) ? true : false,
                state:'s_it10i360',
                pfx:'現客数',
                b_mln:false,
              },
              {
                type: 'Clds',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 'sld_it11ss',
                pfx: '外販担当者',
                b_oneTtl: true,
                dd_defss: {
                  it11b21k: {
                    type:'Pck',
                    b_vsb:true,
                    b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                    b_dlt: true,
                    pfx:'',
                    ld_itemss: global.c?.state.sld_cm10ss,
//                    ld_iss: global.c?.state.sld_cm10ss,
                    onCls:null,
                    onChg:null,
                  },
                },
              },
              {
                type:'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10i110',
                pfx:'コース',
                ld_itemss: global.c?.state.sld_cm50ss,
                onCls:null,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt: (bf.i(global.c?.state.s_it10s110, ['10']) && bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['edit'])) ? true : false,
                state:'s_it10d110',
                pfx:'開始時刻（YYYY-MM-DD hh:mm）',
                b_mln:false,
                o_stlVal: _d => {
                  return _d.val.substr(0,16)
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10d120',
                pfx:'終了時刻', // 商品に延長が登録されている場合は、コース終了日時を調整する必要あり
                b_mln:false,
/*
                onChg: () => {
                  ip._updIt10d130();
                  ip._updIt10d140();
                },
*/
                o_stlVal: _d => {
                  return _d.val.substr(0,16)
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10ia70',
                pfx:'支払総額（税込） ※登録・反映後に更新',
                b_mln:false,
                o_stlVal: pd => {
                  return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10d130',
                pfx:'終了時刻（30分延長）', // 商品に延長が登録されている場合は、コース終了日時を調整する必要あり
                b_mln:false,
                onChg: null,
                o_stlVal: _d => {
                  return _d.val.substr(0,16)
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10ia80',
                pfx:'支払総額（30分延長）',
                b_mln:false,
                onChg:null,
                o_stlVal: pd => {
                  return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10d140',
                pfx:'終了時刻（60分延長）', // 商品に延長が登録されている場合は、コース終了日時を調整する必要あり
                b_mln:false,
                onChg: null,
                o_stlVal: _d => {
                  return _d.val.substr(0,16)
                },
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt:false,
                state:'s_it10ia90',
                pfx:'支払総額（60分延長）',
                b_mln:false,
                onChg:null,
                o_stlVal: pd => {
                  return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                },
              },
              {
                type: 'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10i210',
                pfx: 'ワンドリンクサービス数',
                onChg: null,
              },
              {
                type: 'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10i220',
                pfx: 'サービス#2',
                ld_itemss: [
                    {key:'0', pfx: 'なし'},
                    {key:'10', pfx: 'あり'},
                ],
//                onChg: ip._updIt10ia40,
              },
              {
                type: 'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10i2a0',
                pfx: 'チャージ割引',
                ld_itemss: [
                    {key:'0', pfx: 'チャージあり'}, // 割引なし
                    {key:'10', pfx: 'チャージなし'}, // 割引あり
                ],
//                onChg: ip._updIt10ia40,
              },
              {
                type: 'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10i2b0',
                pfx: '消費税割引',
                ld_itemss: [
                    {key:'0', pfx: '消費税あり'}, // 割引なし
                    {key:'10', pfx: '消費税なし'}, // 割引あり
                ],
//                onChg: ip._updIt10ia40,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10ia50',
                pfx:'会計調整額',
                b_mln:false,
                b_cmm: true,
//                onChg: ip._updIt10ia40,
                onChg: null,
              },
              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10c310',
                pfx:'備考',
                b_mln:true,
                onChg:null,
              },
              {
                type:'Pck',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state:'s_it10b21k',
                pfx:'バインダ（接客開始前に選択要）',
                ld_itemss: global.c?.state.sld_im10ss,
                onCls: null,
                onChg: global.c?._onChgIt10b21k,
              },
              {
                type: 'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt: false,
                state: 's_it10i720',
                pfx: '現金払額',
                b_mln: false,
                onChg: null,
                b_cmm: true,
                o_stlVal: pd => {
                  return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                },
              },
              {
                type: 'Inp',
                b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.i(global.c?.state.s_it10s110, ['10', '20'])) ? true : false,
                b_edt: (global.c?.state.s_it10s110 == '10' && bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                state: 's_it10i730',
                pfx: 'カード払額',
                b_mln: false,
                b_cmm: true,
                o_stlVal: pd => {
                  return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                },
              },
              {
                type: 'Btns',
                b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
                ld_defss: [
                  {
                    pfx: '接客開始',　// 接客開始
                    b_vsb: (global.c?.state.s_it10s110 == '0') ? true : false,
                    b_rvs: (bf.i(global.c?.state.s_it10b21k, ['', '-1']) || bf.i(global.c?.state.s_it10t110, ['', '-1'])) ? true : false,
                    onPrs: (bf.i(global.c?.state.s_it10b21k, ['', '-1']) || bf.i(global.c?.state.s_it10t110, ['', '-1'])) ? null : global.c?._onPrsStt,
                    stlBtn: {
                        width: ic.gn_btnWLrg * 1.5,
                    },
                    stlPfx: {
                    },
                  },
                  {
                    pfx: '接客終了・会計確定', // 会計し接客終了
                    b_vsb: (global.c?.state.s_it10s110 == '10') ? true : false,
                    b_rvs: (bf.n(global.c?.state.s_it10i720) < 0) ? true : false,
                    onPrs: (bf.n(global.c?.state.s_it10i720) >= 0) ? global.c?._onPrsEnd : null,
                    stlBtn: {
                        width: ic.gn_btnWLrg * 1.5,
                    },
                    stlPfx: {
                    },
                  },
                  {
                    pfx: '接客再開',　// 接客開始
                    b_vsb: (global.c?.state.s_it10s110 == '20') ? true : false,
                    onPrs: global.c?._onPrsReStt,
                    stlBtn: {
                      width: ic.gn_btnWLrg * 1.5,
                    },
                    stlPfx: {
                    },
                  },
                ],
                stlCta: {
                  marginTop: ic.gn_mgnLrg,
                  marginBottom: ic.gn_mgnLrg,
                },
              },
              {
                type: 'Clds',
                b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
                b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                b_spr: true,
//                b_plcNewAtTop: false,
                state: 'sld_it30ss',
                pfx: '',
                ob_ftr: _d_is => { // filter
                  let _b = bf.b([
                    {
                      b_when: 
                        global.c?.state.sgcd_pageCmns?.userc410 == '10' &&
                        bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                        bf.i(_d_is.it30t110, ['230']) == false &&
                        String(_d_is._KEY).substr(0, 3) != 'new'
                      ,
                      o_then: () => false,
                    },
                    {
                      o_else: () => true,
                    },
                  ]);
                  return _b;
                },
                ld_sortss: global.c?.state.sld_it30Sortss,
                d_insDats: {
/*
                  it30b21k: 
                    (global.c?.state.sgc_pageName == 'iCmrDtl') ? 
                      global.c?.state.sgcd_pageCmns?.user_key 
                    : 
                      global.c?.state.sgcd_pageCmns?.cm10_key
                  ,
                  it30cy20: 
                    (global.c?.state.sgc_pageName == 'iCmrDtl') ? 
                      global.c?.state.sgcd_pageCmns?.user_key 
                    : 
                      global.c?.state.sgcd_pageCmns?.cm10_key
                  ,
*/
                  it30b21k: global.c?.state.sgcd_pageCmns?.cm10_key,
                  it30cy20: global.c?.state.sgcd_pageCmns?.cm10_key,
                },
                dd_defss: {
                  it30i110: {
                    type:'PckSlc',
                    b_vsb:true,
                    b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                    pfx:'商品',
                    ld_itemss: global.c?.state.sld_cm50ss2,
                    onChg: ip._onChgIt30i110,
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    stlPfx: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: ic.gn_fontSizeNrm * 1.3,
                    },
                    stlCta: {
                      marginTop: 0,
                      marginBottom: 0,
                    },
                  },
                  it30i220: {
                    type:'Inp',
                    b_vsb:true,
                    b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                    pfx:'数量 ※数値のみ',
                    b_mln:false,
                    onBlur: ip._onBlurIt30i220,
                    kbdType: 'numeric',
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    stlInp: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: ic.gn_fontSizeNrm * 1.3,
                    },
                    stlCta: {
                      marginTop: 0,
                      marginBottom: 0,
                    },
                  },
                  dummy2: {
                    type:'Inp',
                    b_vsb:true,
                    b_edt:false,
                    pfx:'税抜額（税抜単価）',
                    b_mln:false,
                    b_cmm: false,
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    stlInp: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: ic.gn_fontSizeNrm * 1.3,
                    },
                    stlCta: {
                      marginTop: 0,
                      marginBottom: 0,
                    },
                    o_ini: (_d_prts, _d_is) => {
                      let _ini = '{}（{}）'.f(
                        bf.myCM_cnv('cmm', _d_is.it30i230 || '0'),
                        bf.myCM_cnv('cmm', _d_is.it30i210 || '0'), 
                      );
                      return _ini;
                    }
                  },
                  it30b21k: {
                    type:'Pck',
                    b_vsb:true,
                    b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])) ? true : false,
                    pfx:'登録者',
//                    ini: global.c?.state.sgcd_pageCmns?.user_key,
                    ld_itemss: global.c?.state.sld_cm10ss,
                    onChg: null,
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    stlPfx: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: ic.gn_fontSizeNrm * 1.3,
                    },
                    stlCta: {
                      marginTop: 0,
                      marginBottom: 0,
                    },
                  },
                  dummy1: {
                    type: 'Clds',
                    ob_vsb: (_d_prts, _d_is) => {
                      let _b = bf.b([
                        {
                          b_when: bf.i(_d_is.it30t110, ['230']),
                          o_then: () => true,
                        },
                        {
                          o_else: () => false,
                        },
                      ]);
//bf.l('875: {}, {}'.f(_b, _d_is.it30t110))
//_b = true;
                      return _b
                    },
//                    b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && global.c?.state.s_it20s110 == '10') ? true : false,
                    b_edt: true,
                    b_spr: false,
                    b_plcNewAtTop: false,
                    state: 'sld_it31ss',
                    prtFld: 'it31b21k', // it30_key
                    o_pfx: _d_is => {
                      let _pfx = bf.b([
                        {
                          b_when: 
                            bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])
                          ,
                          o_then: () => '関与者／関与度',
                        },
                        {
                          o_else: () => '関与者',
                        }
                      ]);
                      return _pfx;
                    },
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    ob_newLine: _d_is => {
                      let _n_cnt = ip.get_cntIt31User({it30_key:_d_is._KEY});                    
                      let _b = bf.b([
                        {
                          b_when: 
                            bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                            bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])
                          ,
                          o_then: () => true,
                        },
                        {
                          b_when: 
                            bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                            bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) &&
                            _n_cnt == 0
                          ,
                          o_then: () => true,
                        },
                        {
                          o_else: () => false,
                        },
                      ]);
//bf.l('919: {}, {}, {}, {}'.f(_b, _n_cnt, global.c?.state.sgcd_pageCmns?.userc410, _d_is._KEY))
//_b = false;
                      return _b; // シャンパンのみ複数登録可能
                    },
                    d_insDats: {
                      it31i110: '1',
                    },
                    b_oneTtl: true,
                    dd_defss: {
                      it31b31k: {
                        type: 'Pck',
                        ob_vsb: (_d_prts, _d_is) => {
                          let _b = bf.b([
                            {
                              b_when: bf.i(_d_prts.it30t110, ['230']),
                              o_then: () => true,
                            },
                            {
                              o_else: () => false,
                            },
                          ]);
                          return _b;
                        },
                        b_dlt: true,
                        ob_edt: (_d_prts, _d_is) => {
                          let _b = bf.b([
                            {
                              b_when:
//                                global.c?.state.s_it20s110 == '10' &&
                                bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                                bf.i(_d_prts.it30t110, ['230']) == true &&
                                (
                                  bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) ||
//                                  bf.n(_d_is.it31b31k) == bf.n(global.c?.state.sgcd_pageCmns?.user_key) ||
                                  bf.n(_d_is.it31b31k) == bf.n(global.c?.state.sgcd_pageCmns?.cm10_key) ||
                                  bf.f(_d_is) == false
                                )
                              ,
                              o_then: () => true,
                            },
                            {
                              o_else: () => false,
                            },
                          ]);
//bf.l('962: {}'.f(_b))
//_b = true;
                          return _b;
                        },
                        pfx: '',
                        phd: '関与者を登録ください',
                        ld_itemss: global.c?.state.sld_cm10ss,
                        ini: null,
                        ctrVal: null,
                        onChg: null,
                        oo_rlcFldPrs: (_d_prts, _d_is) => { // replace fld press
                          if (bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) != true) return null; // キャストの場合のみ置き換え
                          return _d_ids => {
                            let _n_cnt = ip.get_cntIt31User({it30_key:_d_is.it31b21k});
                            if (_n_cnt > 0) return; // 既存データが存在する場合は追加しない
                            global.c?.setState({
                              sld_it31ss: bf.p( global.c?.state.sld_it31ss, _next => {
                                _next.push({
                                  _KEY: 'new',
//                                  it31b31k: global.c?.state.sgcd_pageCmns?.user_key,
                                  it31b31k: global.c?.state.sgcd_pageCmns?.cm10_key,
                                  b_dlt: false,
                                  b_ups: true,
                                  it31b21k: _d_prts._KEY,
                                  it31i110: '1',
                                })
                              }),
                            })
                          };
//return null;                          
                        },
                        stlLbl: {
                          fontSize: ic.gn_fontSizeNrm * 1.05,
                        },
                        stlPfx: {
                          paddingTop: 0,
                          paddingBottom: 0,
                          fontSize: ic.gn_fontSizeNrm * 1.3,
                        },
                        stlCta: {
                          marginTop: 0,
                          marginBottom: 0,
                        },
                      },
                      it31i110: {
                        type: 'Inp',
                        ob_vsb: (_d_prts, _d_is) => {
                          let _b = bf.b([
                            {
                              b_when: 
                                bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) &&
                                bf.i(_d_prts.it30t110, ['230']) &&
                                bf.f(_d_is) == true
                              ,
                              o_then: () => true,
                            },
                            {
                              o_else: () => false,
                            },
                          ]);
                          return _b;
                        }, 
                        b_edt: bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']),
//                        b_edt: true,
                        pfx: '',
                        phd: '関与度を数値で入力ください',
                        onChg: null,
                        b_mln:false,
                        stlLbl: {
                          fontSize: ic.gn_fontSizeNrm * 1.05,
                        },
                        stlInp: {
                          paddingTop: 0,
                          paddingBottom: 0,
                          fontSize: ic.gn_fontSizeNrm * 1.3,
                        },
                        stlCta: {
                          marginTop: 0,
                          marginBottom: 0,
                        },
                      },
                    },
                  },
                  dummy3: {
                    type:'Inp',
                    b_vsb:true,
                    b_edt:false,
                    pfx:'更新者／更新日時',
                    o_ini: (_d_prts, _d_is) => {
                      let _d_cm10s = bf.myCM_get_dct({
                        mode: 'items', 
                        ld_itemss: global.c?.state.sld_cm10ss, 
                        fld:'key', val:bf.n(_d_is.it30cy20)
                      });
                      let _pfx = '';
                      if (bf.f(_d_cm10s)) {
                        _pfx = _d_cm10s.pfx;
                      };
                      let _date = ''
                      if (bf.f(_d_is.it30cy10)) {
                        _date = _d_is.it30cy10.substr(0,16);
                      };
                      let _ini = '{}　{}'.f(
                        _pfx,
                        _date,
                      );
                      return _ini;
                    },
                    onChg: null,
                    stlLbl: {
                      fontSize: ic.gn_fontSizeNrm * 1.05,
                    },
                    stlInp: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: ic.gn_fontSizeNrm * 1.3,
                    },
                    stlCta: {
                      marginTop: 0,
                      marginBottom: 0,
                    },
                  },
                },
              },
            ],
          }}

          d_tops={{
            n_h: ic.gn_fontSizeNrm + ic.gn_bdrWNrw * 2 + ic.gn_mgnNrm * 4,
            ld_defss: [
              {
                type: 'Btns',
                b_vsb: true,
                ld_defss: [
                  {
                    pfx: '基本情報',
                    b_vsb: true,
                    b_rvs: (global.c?.state.sgcn_pageTab == 1) ? false : true,
                    onPrs: () => {
                      global.c?.$onPrsTab({n_tab: 1});
                    },
                    stlBtn: {
                      width: ic.gn_btnWLrg,
                    },
                    stlPfx: {
                    },
                  },
                  {
                    pfx: '注文情報',
                    b_vsb: true,
                    b_rvs: (global.c?.state.sgcn_pageTab == 2) ? false : true,
                    onPrs: () => {
                      global.c?.$onPrsTab({n_tab: 2})
                      .then(() => {
/*
                        if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'edit') {
                          global.c?.setState({
                            sgcb_srlToEnd: true,
                          });
                        };
*/
                      });
                    },
                    stlBtn: {
                      width: ic.gn_btnWLrg,
                    },
                    stlPfx: {
                    },
                  },
                ],
                stlCta: {
                  marginTop: ic.gn_mgnLrg,
                  marginBottom: ic.gn_mgnLrg,
                },
              },
            ],
          }}
        />
      </this.$onChg>
    );
  }

}
